import { defineStore } from "pinia";

export const useDrOnboardingStepsStore = defineStore("drOnboarding", {
  state: () => ({
    drRegister: {},
    step1: { completed: false },
    step2: { completed: false },
    step3: { completed: false },
    step4: { completed: false },
    step5: { completed: false },
    onboardingCompleted: false, // New state to track if onboarding is completed
  }),
  actions: {
    UPDATE_REGISTER_INFO(drRegisterInfo) {
      this.drRegister = drRegisterInfo;
    },
    UPDATE_STEP1_INFO(drStep1Info) {
      this.step1 = { ...drStep1Info, completed: true }; // Mark step1 as completed
    },
    UPDATE_STEP2_INFO(drStep2Info) {
      this.step2 = { ...drStep2Info, completed: true }; // Mark step2 as completed
    },
    UPDATE_STEP3_INFO(drstep3Info) {
      this.step3 = { ...drstep3Info, completed: true }; // Mark step3 as completed
    },
    UPDATE_STEP4_INFO(step4Info) {
      this.step4 = { ...step4Info, completed: true }; // Mark step4 as completed
    },
    UPDATE_STEP5_INFO(step5Info) {
      this.step5 = { ...step5Info, completed: true }; // Mark step5 as completed
    },
    MARK_ONBOARDING_COMPLETED() {
      this.onboardingCompleted = true; // Mark entire onboarding as completed
    },
    RESET_ONBOARDING() {
      // Method to reset onboarding state if needed (e.g., for a new user)
      this.drRegister = {};
      this.step1 = { completed: false };
      this.step2 = { completed: false };
      this.step3 = { completed: false };
      this.step4 = { completed: false };
      this.step5 = { completed: false };
      this.onboardingCompleted = false;
    },
  },
  persist: true, // Optional: persist the state to localStorage/sessionStorage
});